import { render } from "./MovingLayersLogo.vue?vue&type=template&id=61a07d39&ts=true"
import script from "./MovingLayersLogo.vue?vue&type=script&lang=ts"
export * from "./MovingLayersLogo.vue?vue&type=script&lang=ts"

import "./MovingLayersLogo.vue?vue&type=style&index=0&id=61a07d39&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__